import { AuthState } from '@okta/okta-auth-js';
import { useOktaAuth } from '@okta/okta-react';

export const useUserAuthenticationState = (): AuthState | null => {
  const { authState } = useOktaAuth();

  return authState;
};
